import PropTypes from 'prop-types';
import React from 'react';

import { generateClasses, styled } from 'netline-ui';

import LoadingProgress from '../LoadingProgress/LoadingProgress';

const fullScreenLoaderClasses = generateClasses('FullScreenLoader', ['root'] as const);
const FullScreenLoaderRoot = styled(LoadingProgress, { name: fullScreenLoaderClasses.$name })({
  height: '100%',
});

const FullScreenLoader = ({ text = 'Loading...' }) => (
  <FullScreenLoaderRoot className={fullScreenLoaderClasses.root}>{text}</FullScreenLoaderRoot>
);

FullScreenLoader.propTypes = {
  text: PropTypes.string,
};

export default FullScreenLoader;
